module.exports = __webpack_public_path__ + "static/vater-1a0ff1f4a67a1c80e536acba09cf2e13.jpg";